/**
 * Creates an HTML5 Audio Element
 * @class directive_v3sAudio
 * @memberOf v3sWbtPlayerApp:page:media
 */
angular.module('v3sWbtPlayerApp').directive('v3sAudio', ["v3sMediaService", function (v3sMediaService) {
    return {
        restrict: 'E',
        require : '^v3sDocument',
        scope: {
            id: '@',
            v3sFile: '@'
        },
        link: function (scope, element, attrs, docCtrl, transclude) {
            if (!!scope.id) {
                var audio = {
                    id: scope.id,
                    audio: element,
                    file: scope.v3sFile,
                    subtitle: ""
                }

                var subtitle = element.find("v3s-audiotext");
                if (subtitle.length > 0) {
                    audio.subtitle = subtitle.text();
                    subtitle.remove();
                }

                element.find("audio").remove();
                v3sMediaService.createMedia(audio);

                // Als Element hinzufügen, wenn ID vorhanden, aber nicht aus Feedback eingefügt
                if (scope.id && !scope.id.indexOf("feedback-") == 0) {
                    docCtrl.addElement(element);
                }
            }
        }
    }
}]);
